<template>
  <div>
    <div class="main-header-left d-none d-lg-block">
      <div class="logo-wrapper">
        <router-link :to="homePath" v-if="sidebar == 'compact'">
          <img src="../assets/images/logo/compact-logo.png" alt />
        </router-link>
        <router-link :to="homePath" v-else>
          <img src="../assets/images/endless-logo.png" alt />
        </router-link>
      </div>
    </div>
    <div class="sidebar custom-scrollbar">
      <div class="sidebar-user text-center">
        <div>
          <img class="img-60 rounded-circle" src="../assets/images/user/1.jpg" alt="#" />
          <div class="profile-edit">
            <router-link to="/users/edit">
              <vue-feather type="edit"></vue-feather>
            </router-link>
          </div>
        </div>
        <h6 class="mt-3 f-14">{{ sidebarUserName }}</h6>
        <p>{{ sidebarUserRole }}</p>
      </div>
      <ul class="sidebar-menu" id="myDIV"
        :style="[layout.settings.sidebar.type == 'horizontal_sidebar' ? layout.settings.layout_type == 'rtl' ? { 'margin-right': margin + 'px' } : { 'margin-left': margin + 'px' } : { margin: '0px' }]">
        <li class="left-arrow"
          :class="{ 'd-none': layout.settings.layout_type == 'rtl' ? hideLeftArrowRTL : hideLeftArrow }"
          @click="(layout.settings.sidebar.type === 'horizontal_sidebar' && layout.settings.layout_type === 'rtl') ? scrollToLeftRTL() : scrollToLeft()">
          <i class="fa fa-angle-left"></i>
        </li>

        <li v-for="(menuItem, index) in menuItems" :key="index" :class="{ 'active': menuItem.active }">
        
          <a href="javascript:void(0)" class="sidebar-header" v-if="menuItem.type == 'sub'"
            @click="setNavActive(menuItem, index)">
            <vue-feather :type="menuItem.icon" class="top"></vue-feather>
            <span>
              {{ $t(menuItem.title) }}
              <span :class="'badge badge-pill rounded-pill badge-' + menuItem.badgeType" v-if="menuItem.badgeType">{{
                menuItem.badgeValue }}</span>
            </span>
            <i class="fa fa-angle-right pull-right" v-if="menuItem.children"></i>
          </a>
         
          <router-link :to="menuItem.path" class="sidebar-header" v-if="menuItem.type == 'link'" router-link-exact-active>
            <vue-feather :type="menuItem.icon" class="top"></vue-feather>
            <span>
              {{ $t(menuItem.title) }}
              <span :class="'badge badge-' + menuItem.badgeType + ' ms-3'" v-if="menuItem.badgeType">{{
                menuItem.badgeValue }}</span>
            </span>
            <i class="fa fa-angle-right pull-right" v-if="menuItem.children"></i>
          </router-link>
         
          <a :href="menuItem.path" class="sidebar-header" v-if="menuItem.type == 'extLink'"
            @click="setNavActive(menuItem, index)">
            <vue-feather :type="menuItem.icon" class="top"></vue-feather>
            <span>
              {{ $t(menuItem.title) }}
              <span :class="'badge badge-' + menuItem.badgeType + ' ms-3'" v-if="menuItem.badgeType">{{
                menuItem.badgeValue }}</span>
            </span>
            <i class="fa fa-angle-right pull-right" v-if="menuItem.children"></i>
          </a>
        
          <a :href="menuItem.path" target="_blank" class="sidebar-header" v-if="menuItem.type == 'extTabLink'"
            @click="setNavActive(menuItem, index)">
            <vue-feather :type="menuItem.icon" class="top"></vue-feather>
            <span>
              {{ $t(menuItem.title) }}
              <span :class="'badge badge-' + menuItem.badgeType + ' ms-3'" v-if="menuItem.badgeType">{{
                menuItem.badgeValue }}</span>
            </span>
            <i class="fa fa-angle-right pull-right" v-if="menuItem.children"></i>
          </a>
       
          <ul class="sidebar-submenu" v-if="menuItem.children">
            <li v-for="(childrenItem, index) in menuItem.children" :key="index"
              :class="{ 'active': childrenItem.active }">
             
              <a href="javascript:void(0)" v-if="childrenItem.type == 'sub'" @click="setNavActive(childrenItem, index)">
                <i class="fa fa-circle"></i>
                {{ $t(childrenItem.title) }}
                <span :class="'badge badge-' + childrenItem.badgeType + ' pull-right'" v-if="childrenItem.badgeType">{{
                  childrenItem.badgeValue }}</span>
                <i class="fa fa-angle-right pull-right" v-if="childrenItem.children"></i>
              </a>
             
              <router-link :to="childrenItem.path" v-if="childrenItem.type == 'link'" router-link-exact-active>
                <i class="fa fa-circle"></i>
                {{ $t(childrenItem.title) }}
                <span :class="'badge badge-' + childrenItem.badgeType + ' pull-right'" v-if="childrenItem.badgeType">{{
                  childrenItem.badgeValue }}</span>
                <i class="fa fa-angle-right pull-right" v-if="childrenItem.children"></i>
              </router-link>
             
              <a :href="childrenItem.path" v-if="childrenItem.type == 'extLink'">
                <i class="fa fa-circle"></i>
                {{ $t(childrenItem.title) }}
                <span :class="'badge badge-' + childrenItem.badgeType + ' pull-right'" v-if="childrenItem.badgeType">{{
                  childrenItem.badgeValue }}</span>
                <i class="fa fa-angle-right pull-right" v-if="childrenItem.children"></i>
              </a>
             
              <a :href="childrenItem.path" target="_blank" v-if="childrenItem.type == 'extTabLink'">
                <i class="fa fa-circle"></i>
                {{ $t(childrenItem.title) }}
                <span :class="'badge badge-' + childrenItem.badgeType + ' pull-right'" v-if="childrenItem.badgeType">{{
                  childrenItem.badgeValue }}</span>
                <i class="fa fa-angle-right pull-right" v-if="childrenItem.children"></i>
              </a>
             
              <ul class="sidebar-submenu horizontal-child-sub" v-if="childrenItem.children">
                <li v-for="(childrenSubItem, index) in childrenItem.children" :key="index">
                
                  <router-link :to="childrenSubItem.path" v-if="childrenSubItem.type == 'link'" router-link-exact-active>
                    <i class="fa fa-circle"></i>
                    {{ $t(childrenSubItem.title) }}
                    <span :class="'badge badge-' + childrenSubItem.badgeType + ' pull-right'"
                      v-if="childrenSubItem.badgeType">{{ childrenSubItem.badgeValue }}</span>
                    <i class="fa fa-angle-right pull-right" v-if="childrenSubItem.children"></i>
                  </router-link>
                 
                  <a :href="childrenSubItem.path" v-if="childrenSubItem.type == 'extLink'">
                    <i class="fa fa-circle"></i>
                    {{ $t(childrenSubItem.title) }}
                    <span :class="'badge badge-' + childrenSubItem.badgeType + ' pull-right'"
                      v-if="childrenSubItem.badgeType">{{ childrenSubItem.badgeValue }}</span>
                    <i class="fa fa-angle-right pull-right" v-if="childrenSubItem.children"></i>
                  </a>
                
                  <a :href="childrenSubItem.path" target="_blank" v-if="childrenSubItem.type == 'extTabLink'">
                    <i class="fa fa-circle"></i>
                    {{ $t(childrenSubItem.title) }}
                    <span :class="'badge badge-' + childrenSubItem.badgeType + ' pull-right'"
                      v-if="childrenSubItem.badgeType">{{ childrenSubItem.badgeValue }}</span>
                    <i class="fa fa-angle-right pull-right" v-if="childrenSubItem.children"></i>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <li class="right-arrow"
          :class="{ 'd-none': layout.settings.layout_type == 'rtl' ? hideRightArrowRTL : hideRightArrow }"
          @click="(layout.settings.sidebar.type == 'horizontal_sidebar' && layout.settings.layout_type == 'rtl') ? scrollToRightRTL() : scrollToRight()">
          <i class="fa fa-angle-right"></i>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { useI18n } from 'vue-i18n';
import { mapState, mapGetters } from "vuex";
export default {
  name: "SidebarPage",
  setup() {
    const { t } = useI18n();
    return {
      t,
    };
  },
  data() {
    return {
      width: 0,
      height: 0,
      margin: 0,
      hideRightArrowRTL: true,
      hideLeftArrowRTL: true,
      hideRightArrow: true,
      hideLeftArrow: true,
      menuWidth: 0,

    };
  },
  computed: {
    ...mapState({
      menuItems: state => state.menu.data,
      layout: state => state.layout.layout,
      sidebar: state => state.layout.sidebarType
    }),
    ...mapGetters('auth', { tenantUser: 'currentUser' }),
    ...mapGetters('adminAuth', { adminUser: 'currentUser' }),
    isAdminScope() {
      return this.$route.matched.some((r) => r.meta.authScope === 'admin')
    },
    homePath() {
      return this.isAdminScope ? '/admin/dashboard' : '/dashboard'
    },
    sidebarUserName() {
      const user = this.isAdminScope ? this.adminUser : this.tenantUser
      return user?.fullName || 'User'
    },
    sidebarUserRole() {
      return this.isAdminScope ? 'platform admin' : 'firm user'
    },
  },
  created() {

    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    if (this.width < 991) {
      this.layout.settings.sidebar.type = "default";
    }
    const val = this.sidebar
    if (val == 'default') {
      this.layout.settings.sidebar.type = 'default';
      this.layout.settings.sidebar.body_type = 'default';
    } else if (val == 'compact') {
      this.layout.settings.sidebar.type = 'compact-wrapper';
      this.layout.settings.sidebar.body_type = 'sidebar-icon';
    } else if (val == 'compact-icon') {
      this.layout.settings.sidebar.type = 'compact-page';
      this.layout.settings.sidebar.body_type = 'sidebar-hover';
    } else if (val == 'horizontal') {
      this.layout.settings.sidebar.type = 'horizontal_sidebar';
      this.layout.settings.sidebar.body_type = '';
    }
    setTimeout(() => {
      const elmnt = document.getElementById("myDIV");
      this.menuWidth = elmnt.offsetWidth;
      this.menuWidth > window.innerWidth ? (this.hideRightArrow = false, this.hideLeftArrowRTL = false) : (this.hideRightArrow = true, this.hideLeftArrowRTL = true)
    }, 500)
  },
  unmounted() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    this.menuItems.filter(items => {
      if (items.path === this.$route.path)
        this.$store.dispatch("menu/setActiveRoute", items);
      if (!items.children) return false;
      items.children.filter(subItems => {
        if (subItems.path === this.$route.path)
          this.$store.dispatch("menu/setActiveRoute", subItems);
        if (!subItems.children) return false;
        subItems.children.filter(subSubItems => {
          if (subSubItems.path === this.$route.path)
            this.$store.dispatch("menu/setActiveRoute", subSubItems);
        });
      });
    });
  },
  methods: {
    setNavActive(item) {
      this.$store.dispatch("menu/setNavActive", item);
     
    },
    handleResize() {
      this.width = window.innerWidth - 310;
    },
    scrollToRightRTL() {
      this.temp = this.width + this.margin;
     
      if (this.temp === 0) {
        this.margin = this.temp;
        this.hideRightArrowRTL = true;
      }
     
      else {
        this.margin += this.width;
        this.hideRightArrowRTL = false;
        this.hideLeftArrowRTL = false;
      }
    },
    scrollToLeftRTL() {
   
 
      if (this.margin <= -this.width) {
        this.margin += -this.width;
        this.hideLeftArrowRTL = true;
      }
     
      else {
        this.margin += -this.width;
        this.hideRightArrowRTL = false;
      }
    },
    scrollToLeft() {
     

    
      if (this.margin >= -this.width) {
        this.margin = 0;
        this.hideLeftArrow = true;
      }
     
      else {
        this.margin += this.width;
        this.hideRightArrow = false;
      }
    },
    scrollToRight() {
      this.temp = this.menuWidth + this.margin;
     
      if (this.temp < this.menuWidth) {
        this.margin = -this.temp;
        this.hideRightArrow = true;
      }
     
      else {
        this.margin += -this.width;
        this.hideLeftArrow = false;
      }
    }
  }
};
</script>
